import { render } from "./AdvertisingPricing.vue?vue&type=template&id=354bf17b&scoped=true"
import script from "./AdvertisingPricing.vue?vue&type=script&lang=js"
export * from "./AdvertisingPricing.vue?vue&type=script&lang=js"

import "./AdvertisingPricing.vue?vue&type=style&index=0&id=354bf17b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-354bf17b"]])

export default __exports__